import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_state_list = _resolveComponent("ontos-state-list")!
  const _component_ontos_named_list_input = _resolveComponent("ontos-named-list-input")!

  return (_openBlock(), _createBlock(_component_ontos_named_list_input, {
    ref: "identity",
    name: _ctx.value.name,
    alias: _ctx.value.alias,
    "name-label": _ctx.$tt('workflow-name'),
    "fixed-alias": _ctx.fixedAlias,
    "start-with-auto-alias": _ctx.startWithAutoAlias,
    siblings: _ctx.workflows,
    "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => (_ctx.patch('name', $event))),
    "onUpdate:alias": _cache[2] || (_cache[2] = ($event: any) => (_ctx.patch('alias', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ontos_state_list, {
        ref: "states",
        editable: "",
        states: _ctx.value.states,
        title: _ctx.$tt('states'),
        icon: "mdi-format-list-numbered",
        level: 3,
        dense: "",
        "onUpdate:entries": _cache[0] || (_cache[0] = ($event: any) => (_ctx.patch('states', $event)))
      }, null, 8, ["states", "title"])
    ]),
    _: 1
  }, 8, ["name", "alias", "name-label", "fixed-alias", "start-with-auto-alias", "siblings"]))
}